import { inject } from '@angular/core';
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
export class IncomeDataService {
    constructor() {
        this._ajaxService = inject(AjaxService);
        this._urlsService = inject(UrlsService);
    }
    fetchFundHistoricDistribution(fund, yearLookback, distributionType, customValue) {
        return this._ajaxService.getDataObserveBody(this._urlsService.SECURITIES.FUND_HISTORIC_DISTRIBUTION, {
            fund,
            year_lookback: yearLookback ?? '',
            distribution_type: distributionType,
            custom_value: customValue,
        });
    }
}
IncomeDataService.ɵfac = function IncomeDataService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IncomeDataService)(); };
IncomeDataService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IncomeDataService, factory: IncomeDataService.ɵfac, providedIn: 'root' });
